import {createStore, combineReducers} from 'redux';
import filterReducer, {DATE_USERS} from '../reducers/filters';
import processReducer from '../reducers/process';
import dataReducer from '../reducers/data';
import {getStoredPort, getStoredProducts, getStoredAuthUrl, getStoredStatServerUrl} from "../service/localStorageService";
import {getCurrentDate} from "../service/getCurrentDate";
import userReducer from '../reducers/user'

function initState() {
    return {
        filters : defaultFilters
    }
}

export const LOGIN_PORT = '8080';
export const MAIN_PORT = '8001';
export const LOCALHOST = 'localhost'
export const LOGIN_SERVER = 'api.nau-ra.ru'
export const STAT_SERVER = 'stat.ed-consult.ru'

export const defaultFilters={
    startDate:getCurrentDate(),
    endDate:getCurrentDate(),
    key:'',
    path:DATE_USERS,
    limit:100,
    authUrl: getStoredAuthUrl() || LOGIN_SERVER,
    statServerUrl: getStoredStatServerUrl() || STAT_SERVER,
    port: getStoredPort() || MAIN_PORT,
    products:getStoredProducts(),
    clearResults: {dateusers: false, usage: false, metrika: false, exceptions: false},
    curPages: {dateusers: 1, exceptions: 1}
};

export default ()=>{
    return createStore(combineReducers({filters: filterReducer, process:processReducer,data:dataReducer, user :userReducer}),initState());

};

